import { render } from "./Sites.vue?vue&type=template&id=a1746766"
import script from "./Sites.vue?vue&type=script&lang=js"
export * from "./Sites.vue?vue&type=script&lang=js"
script.render = render

export default script